module.exports = __webpack_public_path__ + "img/use-app-2.26f5f3e9.jpg";